import { motion } from "framer-motion";

const ChristmasHero = () => {
  return (
    <section
    className="
    relative
    min-h-[90vh]
    overflow-hidden
    flex
    items-center
    justify-center
    bg-gradient-to-b
    from-[#0b1f18]
    via-[#163b2b]
    via-[#254b38]
    to-[#6fa8c9]
    "
    >

      {/* Christmas texture overlay */}
      <div
        className="
        absolute
        inset-0
        opacity-20
        bg-[radial-gradient(circle_at_top,_#c7a65a,_transparent_35%)]
        "
      />




      <motion.div
        initial={{
          opacity:0,
          y:40
        }}
        animate={{
          opacity:1,
          y:0
        }}
        transition={{
          duration:1
        }}
        className="
        relative
        z-10
        text-center
        px-6
        "
      >

        <p
          className="
          text-[#d8c38a]
          uppercase
          tracking-[0.5em]
          text-sm
          mb-6
          "
        >
          Festive Season 2026
        </p>



        <h1
        className="
        text-5xl
        md:text-7xl
        font-serif
        text-[#f7f0df]
        leading-tight
        "
        >
        Celebrate Christmas
        <span
            className="
            block
            italic
            text-[#d8c38a]
            mt-3
            "
        >
            At The Fo<span className="text-[#b21f2d]">x</span>
        </span>
        </h1>


        <div
          className="
          w-24
          h-px
          bg-[#d8c38a]
          mx-auto
          my-10
          "
        />


        <p
          className="
          max-w-2xl
          mx-auto
          text-white/85
          text-lg
          md:text-xl
          "
        >
          Join us this Christmas for festive dining,
          unforgettable celebrations and magical evenings
          with friends and family.
        </p>



        {/* Scroll */}
        <motion.div
          animate={{
            y:[0,12,0]
          }}
          transition={{
            duration:1.5,
            repeat:Infinity
          }}
          className="
          mt-16
          "
        >

          <p
            className="
            text-white/70
            text-xs
            uppercase
            tracking-widest
            mb-4
            "
          >
            Discover what's on
          </p>


          <div
            className="
            mx-auto
            w-8
            h-8
            border-r
            border-b
            border-white
            rotate-45
            "
          />

        </motion.div>


      </motion.div>


      {/* Smooth transition into next section */}
      <div
        className="
        absolute
        bottom-0
        left-0
        right-0
        h-40
        bg-gradient-to-t
        from-[#6fa8c9]
        to-transparent
        "
      />

    </section>
  );
};

export default ChristmasHero;